"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    filterTrigger: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold
    },
    filterAndSortBar: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(3, 0),
      borderTop: "1px solid ".concat(theme.palette.grey[400]),
      borderBottom: "1px solid ".concat(theme.palette.grey[400]),
      backgroundColor: theme.palette.common.white
    }, theme.breakpoints.up('md'), {
      display: 'none'
    }),
    filterIcon: {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(0.5, 0),
      '& svg': {
        marginRight: theme.spacing(2)
      }
    },
    facetCountContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    facetCount: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '24px',
      height: '24px',
      border: "1px solid ".concat(theme.palette.primary.main),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightBold,
      marginRight: theme.spacing(2)
    }
  };
});
var FilterAndSortBar = function FilterAndSortBar(_ref) {
  var selectedFacets = _ref.selectedFacets,
    handleOnClick = _ref.handleOnClick,
    filtersLabel = _ref.filtersLabel,
    filterAndSortLabel = _ref.filterAndSortLabel;
  var classes = useStyles();
  var hasSelectedFacets = selectedFacets && selectedFacets.length > 0;
  return __jsx("div", {
    className: classes.filterAndSortBar
  }, __jsx(_core.ButtonBase, {
    className: classes.filterTrigger,
    onClick: handleOnClick
  }, hasSelectedFacets ? __jsx("div", {
    className: classes.facetCountContainer
  }, __jsx("span", {
    className: classes.facetCount
  }, selectedFacets.length), ' ', filtersLabel) : __jsx("span", {
    className: classes.filterIcon
  }, __jsx(_FilterList.default, null), filterAndSortLabel)));
};
var _default = FilterAndSortBar;
exports.default = _default;